<script>
  import * as _ from "lodash";
  import QuickOrderListGroup from "@retailer/svelte/Shared/QuickOrderList/QuickOrderListGroup.svelte";
  import retailerContext from "@modern/services/retailer_context";
  import { ListType, ProtectedListName } from "@shared/types/QuickOrderList";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  export let filter;
  export let filters;
  export let lists;
  export let page;
  export let showLoading = false;
  export let smartFilterDistributor = undefined;

  let retailer = retailerContext.get();
  let limitedOrderingRetailer =
    retailer.limited_ordering && stagedRolloutCheck("adm__dynamic_limited_ordering_filters");
  let approvedProductsListType = limitedOrderingRetailer
    ? ListType.ApprovedProducts
    : ListType.MySavedProducts;
  let approvedProductsListName = limitedOrderingRetailer
    ? ProtectedListName.ApprovedProducts
    : ProtectedListName.MySavedProducts;

  $: listType = smartFilterDistributor ? ListType.DistributorFilter : approvedProductsListType;

  $: approvedProductsList = () => {
    return {
      allow_editing_of_auto_generated: false,
      auto_generated: true,
      id: 0,
      limited_ordering: limitedOrderingRetailer,
      name: approvedProductsListName,
      retailer_id: retailer.id,
      for_sculpture_retailer: retailer.has_sculpture,
      sculpture_retailer_id: null,
      sculpture_report_date: null,
      retailer: lists.length != 0 ? lists[0].retailer : {},
      loading: false,
      list_type: listType,
      lists: [
        {
          id: 0,
          name: approvedProductsListName,
        },
      ],
    };
  };

  let selectFilter = function (event) {
    filter(event);
  };
</script>

<div class="fizz-styles">
  <QuickOrderListGroup
    list={approvedProductsList()}
    {listType}
    {lists}
    {page}
    {filters}
    {showLoading}
    {smartFilterDistributor}
    {retailer}
    on:selectFilter={selectFilter}
    callbacks={{}}
  />
</div>
